// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-modal.open-chat-popover div.modal-wrapper {
  overflow: auto;
}
@media only screen and (min-width: 400px) {
  ion-modal.open-chat-popover div.modal-wrapper {
    left: 12.5vw;
  }
}
@media only screen and (min-height: 200px) {
  ion-modal.open-chat-popover div.modal-wrapper {
    left: 12.5vw;
  }
}
@media only screen and (max-width: 399px) {
  ion-modal.open-chat-popover div.modal-wrapper {
    left: calc(50% - 150px);
  }
}

ion-content {
  --background: transparent;
  --padding-bottom: 16px;
  --padding-end: 16px;
  --padding-start: 16px;
  --padding-top: 16px;
}

h4 {
  margin-top: 0;
  margin-bottom: 10px;
  font-size: 20px;
  color: var(--ion-color-helpinghand-headline);
}

.info {
  font-size: 14px;
}
.info.task-title {
  margin-top: 3px;
  margin-bottom: 6px;
  font-weight: bold;
  color: var(--ion-color-helpinghand-text);
}
.info.task-type-info {
  margin-top: 8px;
  color: var(--ion-color-helpinghand-text);
}
.info.task-date-info {
  margin-top: -12px;
  margin-bottom: 8px;
  text-transform: capitalize;
  color: var(--ion-color-helpinghand-text);
}

ion-item {
  --padding-start: 0px;
  --background: var(--ion-color-chat-textareat-background);
  border: 0.55px solid #999;
}

ion-textarea {
  --padding-start: 8px !important;
  resize: none;
  font-size: 14px;
  color: #757575;
}
@media only screen and (orientation: landscape) {
  ion-textarea {
    height: 120px;
  }
}
@media only screen and (orientation: portrait) {
  ion-textarea {
    height: 200px;
  }
}

.bottom-buttons {
  padding: 16px;
  justify-content: flex-end;
}
.bottom-buttons ion-button {
  margin-left: 15px;
  min-width: 100px;
  height: 40px;
  font-weight: 600;
  font-size: 1rem;
  text-transform: uppercase;
  --border-radius: 0 !important;
  --color: var(--ion-button-color-white);
  --background: var(--ion-color-chat-send-button);
}
.bottom-buttons ion-button:hover {
  background-color: rgba(158, 158, 158, 0.1);
}

.calendar {
  width: 100%;
  max-width: 390px;
}`, "",{"version":3,"sources":["webpack://./src/components/register-for-task/register-for-task.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;AACJ;AACI;EAHJ;IAIQ,YAAA;EAEN;AACF;AAAI;EAPJ;IAQQ,YAAA;EAGN;AACF;AADI;EAXJ;IAYQ,uBAAA;EAIN;AACF;;AADA;EACI,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;AAIJ;;AADA;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,4CAAA;AAIJ;;AADA;EACI,eAAA;AAIJ;AAFI;EACI,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,wCAAA;AAIR;AADI;EACI,eAAA;EACA,wCAAA;AAGR;AAAI;EACI,iBAAA;EACA,kBAAA;EACA,0BAAA;EACA,wCAAA;AAER;;AAEA;EACI,oBAAA;EACA,wDAAA;EACA,yBAAA;AACJ;;AAEA;EACI,+BAAA;EAOA,YAAA;EACA,eAAA;EACA,cAAA;AALJ;AAHI;EAFJ;IAGQ,aAAA;EAMN;AACF;AALI;EALJ;IAMQ,aAAA;EAQN;AACF;;AAFA;EACI,aAAA;EACA,yBAAA;AAKJ;AAHI;EACI,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EAEA,6BAAA;EACA,sCAAA;EACA,+CAAA;AAIR;AAFQ;EACI,0CAAA;AAIZ;;AACA;EACI,WAAA;EACA,gBAAA;AAEJ","sourcesContent":["ion-modal.open-chat-popover div.modal-wrapper {\n    overflow: auto;\n\n    @media only screen and (min-width: 400px) {\n        left: calc(50vw - (75vw / 2));\n    }\n\n    @media only screen and (min-height: 200px) {\n        left: calc(50vw - (75vw / 2));\n    }\n\n    @media only screen and (max-width: 399px) {\n        left: calc(50% - (300px / 2));\n    }\n}\n\nion-content {\n    --background: transparent;\n    --padding-bottom: 16px;\n    --padding-end: 16px;\n    --padding-start: 16px;\n    --padding-top: 16px;\n}\n\nh4 {\n    margin-top: 0;\n    margin-bottom: 10px;\n    font-size: 20px;\n    color: var(--ion-color-helpinghand-headline);\n}\n\n.info {\n    font-size: 14px;\n\n    &.task-title {\n        margin-top: 3px;\n        margin-bottom: 6px;\n        font-weight: bold;\n        color: var(--ion-color-helpinghand-text);\n    }\n\n    &.task-type-info {\n        margin-top: 8px;\n        color: var(--ion-color-helpinghand-text);\n    }\n\n    &.task-date-info {\n        margin-top: -12px;\n        margin-bottom: 8px;\n        text-transform: capitalize;\n        color: var(--ion-color-helpinghand-text);\n    }\n}\n\nion-item {\n    --padding-start: 0px;\n    --background: var(--ion-color-chat-textareat-background);\n    border: 0.55px solid #999;\n}\n\nion-textarea {\n    --padding-start: 8px !important;\n    @media only screen and (orientation: landscape) {\n        height: 120px;\n    }\n    @media only screen and (orientation: portrait) {\n        height: 200px;\n    }\n    resize: none;\n    font-size: 14px;\n    color: #757575;\n}\n\n.bottom-buttons {\n    padding: 16px;\n    justify-content: flex-end;\n\n    ion-button {\n        margin-left: 15px;\n        min-width: 100px;\n        height: 40px;\n        font-weight: 600;\n        font-size: 1rem;\n        text-transform: uppercase;\n\n        --border-radius: 0 !important;\n        --color: var(--ion-button-color-white);\n        --background: var(--ion-color-chat-send-button);\n\n        &:hover {\n            background-color: rgba(158, 158, 158, 0.1);\n        }\n    }\n}\n\n.calendar {\n    width: 100%;\n    max-width: 390px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
